import { getFormData } from 'utils/dom'

export default function newsletter() {
    // Placeholder for when we can import app/routes
    const routes = {
        subscribeNewsletter: 'subscribenewsletter',
    }

    function newsletter_subscribe(subscribe) {
        const subscribeProgress = document.querySelector('#subscribe-loading-progress');
        const email = document.querySelector('#newsletter-email').value;
        const newsletter = document.querySelector('#newsletter-subscribe-block');
        const result = document.querySelector('#newsletter-result-block');
        subscribeProgress.style.display = 'block';

        const showThankYou = txt => {
            newsletter.style.display = 'none'
            result.innerHTML += txt
            result.style.display = 'block'
        }

        const postData = {
            subscribe,
            email,
        }

        const formData = getFormData(postData)

        try {
            fetch(routes.subscribeNewsletter, {
                method: 'POST',
                body: formData,
            })
                .then(res => {
                    if (res.status == 200) {
                        return res.json()
                    }
                })
                .then(data => {
                    if (data.Success && data.Result) {
                        showThankYou(data.Result)
                    }
                })
        } catch (err) {
            console.warn(err)
        } finally {
            subscribeProgress.style.display = 'none'
        }
    }

    const newsletterInput = document.querySelector('#newsletter-email')
    const btn = document.querySelector('#newsletter-subscribe-button')

    if (newsletterInput && btn) {
        newsletterInput.addEventListener('keyup', event => {
            if (event.keyCode == 13) {
                btn.click()
            }
        })
    }
    if (btn) {
        btn.addEventListener('click', () => {
            newsletter_subscribe(true)
        })
    }
}
